"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : MENU : TITLE : STYLES --------------- ++++++++++ */


var _default = {
  menuitem: {
    cursor: 'pointer',
    borderBottom: (0, _index.replacePXinStringWithEM)("1px solid ".concat(_index.theme.color.neutral.light.swatch)),
    color: _index.theme.color.primary.dark.swatch,
    fontSize: 'inherit',
    display: 'block',
    minWidth: (0, _index.pxToEm)(230),
    textAlign: 'left',
    // animation
    transition: _index.theme.animation.general('background'),
    '& .link': {
      width: '100%',
      height: '100%',
      padding: (0, _index.replacePXinStringWithEM)("20px"),
      '& a': {
        width: '100%',
        height: '100%'
      },
      '& .icon': {
        width: (0, _index.pxToEm)(15),
        marginRight: (0, _index.pxToEm)(20)
      }
    },
    '&.disabled-true': {
      color: _index.theme.color.neutral.light.swatch,
      cursor: 'default',
      pointerEvents: 'none'
    },
    // round corners to match menu
    '&:first-child': {
      borderTopLeftRadius: 'inherit',
      borderTopRightRadius: 'inherit'
    },
    '&:last-child': {
      borderBottomLeftRadius: 'inherit',
      borderBottomRightRadius: 'inherit'
    },
    // hover 
    '&:hover': {
      background: _index.theme.color.secondary.xlight.swatch
    }
  }
};
exports.default = _default;